import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import { getSamenergiHeaderText } from 'helpers/samEnergi.helper/samEnergi.helper'
import { useTimeoutInterval } from 'hooks/utilsHooks/utilsHooks'
import moment from 'moment'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MetricField from 'ui/components/MetricField/MetricField'

import styles from './SamEnergiHeader.module.less'

export const CounterContentClass = `CounterContentClass`

export default function SamEnergiHeader(): ReactElement {
  const { t } = useTranslation()

  const dueDateToday = moment().hours(13).minutes(20)
  const [secondsToSubmit, setSecondsToSubmit] = useState(() => moment(dueDateToday).diff(moment(), `seconds`))

  function updateAll(): void {
    const timeToSubmit = moment(dueDateToday).diff(moment(), `seconds`)
    setSecondsToSubmit(timeToSubmit)
  }

  useTimeoutInterval({
    startTime: moment().add(1, `minute`).seconds(0),
    interval: 60 * 1000,
    callback: updateAll,
  })

  const headerText = getSamenergiHeaderText(secondsToSubmit)
  const secondDiff = secondsToSubmit < 0 ? secondsToSubmit + 86400 : secondsToSubmit
  const hours = Math.floor(secondDiff / 3600)
  const minutes = Math.floor((secondDiff / 60) % 60)
  return (
    <Grid container sx={{ flexGrow: 1 }} size={{ xs: 12, lg: 7 }} className={CounterContentClass}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h1" className={styles.SamEnergiHeader_H3}>
          {t(`Time until next automatic submission`)}
        </Typography>
      </Grid>
      <Grid
        container
        sx={{ flexGrow: 1 }}
        direction="row"
        size={{ xs: 12 }}
        alignItems="flex-end"
        wrap="nowrap"
        columnSpacing={1}
      >
        <Grid sx={{ flex: '0 0 auto', pr: 1 }}>
          <MetricField value={hours} unit="h" />
        </Grid>
        <Grid sx={{ flex: '0 0 auto', pr: 2 }}>
          <MetricField value={minutes} unit="min" />
        </Grid>
        <Grid sx={{ minWidth: 0, flexGrow: 1 }}>
          <Typography variant="body2" className={styles.SamEnergiHeader_SmallText} noWrap sx={{ display: 'block' }}>
            {headerText}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
